import styled from '@emotion/styled';
import { Button as CommonButton, Stack } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Button = styled(CommonButton)`
  min-width: 59px;
  width: 59px;
  height: 59px;
  opacity: ${VIEWER_Z_INDEX.desktopLayer};
  transition: opacity 0.15s ease-in-out, width 0.15s ease-in-out;

  &.disable {
    cursor: initial;
    opacity: 0.25;

    &:hover {
      border-color: ${theme.colors.zinc_200};
      background-color: ${theme.colors.white};
      color: ${theme.colors.zinc_400};
    }
  }

  &:hover {
    width: fit-content;
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const Dropdown = styled(Stack)`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.zinc_200};
  border-radius: 12px;
  padding: 8px;
  min-width: 160px;
  max-height: 320px;
  overflow-y: auto;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
`;

export const LanguageItem = styled.button<{ isActive: boolean }>`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 8px;
  background-color: ${({ isActive }) =>
    isActive ? theme.colors.zinc_100 : 'transparent'};
  color: ${({ isActive }) =>
    isActive ? theme.colors.zinc_900 : theme.colors.zinc_600};
  font-size: 14px;
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  transition: background-color 0.1s ease-in-out;

  &:hover {
    background-color: ${theme.colors.zinc_100};
    color: ${theme.colors.zinc_900};
  }
`;
